﻿'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:SearchesController
 * @description
 * # SearchesController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('SearchesController', ['$scope', function ($scope) {
      $scope.dataLoaded = false;
      $scope.data = null;
      $scope.tiles = [];
      $scope.id = null;

  }]);